import { Component, Output, OnInit, ElementRef, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { SearchService } from '../shared/search.service';
import { ContentService } from '../shared/content.service';
import { Content } from '../shared/content';
import { UtilsService } from '../shared/utils.service';
import { MetaService } from '../shared/meta.service';
import { IntlService } from '../shared/intl.service';
import { ConfigService } from '../shared/config.service';

@Component({
    template: require('./partials/content-message-edit.component.html'),
    providers: [DatePipe]
})
export class ContentMessageEditComponent extends Content implements OnInit {// 

    public action: string = 'add';
    messageForm: FormGroup;

    constructor (public messageConfig: ConfigService, private messageIntlService: IntlService, private messageMetaService: MetaService, public el: ElementRef, private searchService: SearchService, private datePipe: DatePipe,private utils: UtilsService, private formBuilder: FormBuilder, private router: Router, private messageService: ContentService, private messageRoute: ActivatedRoute) {
        super(messageConfig, messageIntlService, messageMetaService, messageService, messageRoute);
        this.setType('message');
    }

    ngOnInit() {

        this.messageRoute.params.subscribe((params: Params) => {
            
            // Need to init the form for the view, for some reason
            let group = this.buildGroupForm(true,{});
            this.messageForm = this.formBuilder.group(group);

            if(params['id']!=0) {
                this.action='update';
                this.messageService.getContent(this.type, {_id: params['id']}, true).then(response => {
                    this.content = response;
                    let group = this.buildGroupForm(false,this.content);
                    this.messageForm = this.formBuilder.group(group);
                });
            }
        });

        this.messageRoute.parent.params.subscribe((params: Params) => {
            // Current language
            this.currentLanguage = params['lg'];
        });

    }

    buildGroupForm(isNew: boolean, content: any){
        let group = {};
        if(!isNew) 
            group['_id'] = content._id;
        group['cid'] = [content.cid,[]]; // null for new entry
        group['label'] = [content.label,[]];
        group['url'] = [content.url,[]];
        group['active'] = [isNew ? false : content.active,[]]; // not active when new
        group['title'] = isNew ? 
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.title);
        group['subtitle'] = isNew ? 
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.subtitle);
        group['content'] = isNew ? 
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.content);
        group['date'] = [this.datePipe.transform(isNew ? new Date() : content.date, 'yyyy-MM-dd'),[]];
        group['update_date'] = [isNew ? null : this.datePipe.transform(content.update_date, 'yyyy-MM-dd'),[]];
        return group;
    }

    onSubmit(){
        // update date
        this.messageForm.controls['update_date'].setValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));
        // save
        this.messageService.saveContent('message', this.action, this.messageForm.value).then(res =>{
            //console.log('form', this.messageForm.value);
            // this.router.navigate(['messages'], {relativeTo: this.route.parent});
            this.router.navigate(['messages/reload'], {relativeTo: this.route.parent});
            setTimeout(() => {
                this.router.navigate(['messages'], {relativeTo: this.route.parent});
            }, 500);  
        })
    }

    public deleteContent(type: string, id: string){ 
        this.messageService.deleteContent(type,id);
        this.router.navigate(['messages/reload'], {relativeTo: this.route.parent});
        setTimeout(() => {
            this.router.navigate(['messages'], {relativeTo: this.route.parent});
        }, 500);  
    }

    keyupEditorHandlerFunction(fieldPath: string[], text: string){
        this.messageForm.get(fieldPath).patchValue(text);
        //console.log(text);
    }

} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-message-edit.component.ts